(ns app.domain.package.model
  (:require #?(:clj [ring.util.http-response :as resp])
            #?(:cljs [re-frame.core-instrumented :as rf])
            [app.domain.template.model :as template-model]))

(def package-pdf-sections-for-ce
  [:package-section/cover-page
   :package-section/table-of-contents
   :package-section/chain-of-events
   :package-section/complaints
   :package-section/complaint-photos
   :package-section/forms
   :package-section/property-units
   :package-section/internal-notes
   :package-section/inspections
   :package-section/inspection-photos
   :package-section/emails
   :package-section/messaging
   :package-section/fees
   :package-section/media-attachments
   :package-section/generated-documents])

(def package-pdf-sections-for-b
  [:package-section/cover-page
   :package-section/table-of-contents
   :package-section/chain-of-events
   :package-section/forms
   :package-section/property-units
   :package-section/processing-times
   :package-section/internal-notes
   :package-section/inspections
   :package-section/inspection-photos
   :package-section/emails
   :package-section/messaging
   :package-section/fees
   :package-section/reviews
   :package-section/circulations
   :package-section/attachments
   :package-section/generated-documents])

(def package-pdf-sections-for-p
  [:package-section/cover-page
   :package-section/table-of-contents
   :package-section/chain-of-events
   :package-section/forms
   :package-section/property-units
   :package-section/pre-consultation
   :package-section/processing-times
   :package-section/internal-notes
   :package-section/committee-meetings
   :package-section/conditions
   :package-section/reviews
   :package-section/circulations
   :package-section/attachments
   :package-section/public-notice
   :package-section/emails
   :package-section/messaging
   :package-section/fees])

(def package-pdf-sections-for-l
  [:package-section/cover-page
   :package-section/table-of-contents
   :package-section/chain-of-events
   :package-section/forms
   :package-section/circulations
   :package-section/reviews
   :package-section/parties
   :package-section/attachments
   :package-section/inspections
   :package-section/emails
   :package-section/messaging
   :package-section/fees
   :package-section/internal-notes])

(def package-pdf-sections-for-ls
  [:package-section/cover-page
   :package-section/table-of-contents
   :package-section/chain-of-events
   :package-section/parties
   :package-section/attachments
   :package-section/inspections
   :package-section/emails
   :package-section/fees
   :package-section/internal-notes])

(def package-pdf-sections-for-cr
  [:package-section/cover-page
   :package-section/table-of-contents
   :package-section/chain-of-events
   :package-section/forms
   :package-section/attachments
   :package-section/emails
   :package-section/messaging
   :package-section/fees
   :package-section/internal-notes])

(def package-pdf-sections-for-pw
  [:package-section/cover-page
   :package-section/table-of-contents
   :package-section/chain-of-events
   :package-section/forms
   :package-section/property-units
   :package-section/processing-times
   :package-section/internal-notes
   :package-section/inspections
   :package-section/inspection-photos
   :package-section/complaint-photos
   :package-section/emails
   :package-section/messaging
   :package-section/fees
   :package-section/reviews
   :package-section/circulations
   :package-section/attachments
   :package-section/generated-documents])

(def package-pdf-sections-for-lu
  [:package-section/cover-page
   :package-section/table-of-contents
   :package-section/chain-of-events
   :package-section/forms
   :package-section/property-units
   :package-section/pre-consultation
   :package-section/processing-times
   :package-section/internal-notes
   :package-section/conditions
   :package-section/committee-meetings
   :package-section/emails
   :package-section/fees
   :package-section/circulations
   :package-section/public-notice])

(def package-pdf-sections-for-pwo
  [:package-section/cover-page
   :package-section/public-notice
   :package-section/forms
   :package-section/complaint-photos
   :package-section/conditions
   :package-section/chain-of-events
   :package-section/inspection-photos
   :package-section/circulations])

(def optional-sections
  #{:package-section/forms
    :package-section/fees
    :package-section/inspection-photos
    :package-section/complaint-photos
    :package-section/emails
    :package-section/chain-of-events
    :package-section/pre-consultation
    :package-section/processing-times
    :package-section/internal-notes
    :package-section/conditions
    :package-section/committee-meetings
    :package-section/circulations
    :package-section/public-notice})

(def attachment-sections-for-p
  #{:package-attachment/agreements
    :package-attachment/council-decisions
    :package-attachment/reports})

(def attachment-sections-for-lu
  #{:package-attachment/council-decisions})

(def attachment-sections-for-l
  #{})

(def attachment-sections-for-ls
  #{})

(def attachment-sections-for-cr
  #{})

(def attachment-sections-for-pw
  #{})

(def ce-template-variables
  (-> template-model/workspace-header-placeholders
      (into ["category"
             "additional-categories"
             "case-description"
             "address"])
      (into template-model/address-placeholders)
      (into ["property-information"
             "location-information"
             "parties"])
      (into template-model/workspace-footer-placeholders)))

(def b-template-variables
  (-> template-model/workspace-header-placeholders
      (into ["category"
             "permit-description"
             "address"])
      (into template-model/address-placeholders)
      (into ["property-information"
             "parties"
             "review-comments"
             "latest-review-comments"])
      (into template-model/workspace-footer-placeholders)))

(def p-template-variables
  (-> template-model/workspace-header-placeholders
      (into ["category"
             "address"])
      (into template-model/address-placeholders)
      (into ["property-information"
             "parties"
             "created-date"
             "submitted-date"
             "completed-date"
             "workspace-state"
             "assignee"
             "date-generated"
             "review-comments"
             "latest-review-comments"])))

(def l-template-variables
  (-> template-model/workspace-header-placeholders
      (into ["licence-number"
             "category"
             "address"])
      (into template-model/address-placeholders)
      (into ["property-information"
             "location-information"
             "parties"])
      (into template-model/workspace-footer-placeholders)
      (into ["submitted-date"
             "date-issued"
             "valid-from"
             "valid-to"
             "workspace-state"
             "review-comments"
             "latest-review-comments"])))

(def lu-template-variables
  ["header"
   "workspace-id"
   "municipal-case-number"
   "category"
   "address"
   "property-information"
   "parties"
   "created-date"
   "submitted-date"
   "completed-date"
   "workspace-state"
   "assignee"
   "date-generated"
   "review-comments"
   "latest-review-comments"])

(def cr-template-variables
  (-> template-model/workspace-header-placeholders
      (into ["category-cr"
             "case-description"
             "address"])
      (into template-model/address-placeholders)
      (into ["property-information"
             "location-information"
             "parties"])
      (into template-model/workspace-footer-placeholders)
      (into ["submitted-date"
             "date-issued"
             "valid-from"
             "valid-to"
             "workspace-state"])))

(def pw-template-variables
  (-> template-model/workspace-header-placeholders
      (into ["category"
             "permit-description"
             "address"])
      (into template-model/address-placeholders)
      (into ["property-information"
             "parties"
             "review-comments"
             "latest-review-comments"])
      (into template-model/workspace-footer-placeholders)))

(def pwo-template-variables
  (-> template-model/workspace-header-placeholders
      (into ["category"
             "case-description"
             "address"])
      (into template-model/address-placeholders)
      (into ["property-information"
             "location-information"
             "parties"])
      (into template-model/workspace-footer-placeholders)))

(def party-snippet-variables
  template-model/party-placeholders)

(defn- unimplemented-error-handler []
  #?(:clj  (resp/not-implemented! {:error :error/permit-type-not-implemented})
     :cljs (rf/dispatch [:notifications/add :toast :error :error :error/permit-type-not-implemented])))

(defn name-for-type [tr permit-type]
  (tr [(keyword "package-pdf-template.default-name" (name permit-type))
       :package-pdf-template.default-name/default]))

(defn sections-for-type [permit-type]
  (case permit-type
    (:permit-type/B :permit-type/BS :permit-type/SW) package-pdf-sections-for-b
    :permit-type/CE                  package-pdf-sections-for-ce
    :permit-type/P                   package-pdf-sections-for-p
    :permit-type/LU                  package-pdf-sections-for-lu
    :permit-type/L                   package-pdf-sections-for-l
    :permit-type/LS                  package-pdf-sections-for-ls
    :permit-type/CR                  package-pdf-sections-for-cr
    :permit-type/PW                  package-pdf-sections-for-pw
    :permit-type/PWO                 package-pdf-sections-for-pwo
    (unimplemented-error-handler)))

(defn attachments-for-type [permit-type]
  (case permit-type
    :permit-type/P  attachment-sections-for-p
    :permit-type/LU attachment-sections-for-lu
    :permit-type/L  attachment-sections-for-l
    :permit-type/LS attachment-sections-for-ls
    :permit-type/CR attachment-sections-for-cr
    :permit-type/PW attachment-sections-for-pw
    #{}))

(defn html-for-type [permit-type]
  (case permit-type
    (:permit-type/B :permit-type/BS :permit-type/SW) :package-fragment/html-b-template
    :permit-type/CE                  :package-fragment/html-ce-template
    :permit-type/P                   :package-fragment/html-p-template
    :permit-type/LU                  :package-fragment/html-lu-template
    (:permit-type/L :permit-type/LS) :package-fragment/html-l-template
    :permit-type/CR                  :package-fragment/html-cr-template
    :permit-type/PW                  :package-fragment/html-pw-template
    :permit-type/PWO                 :package-fragment/html-pwo-template
    (unimplemented-error-handler)))

(defn variables-for-type [permit-type]
  (case permit-type
    (:permit-type/B :permit-type/BS :permit-type/SW) b-template-variables
    :permit-type/CE                  ce-template-variables
    :permit-type/P                   p-template-variables
    :permit-type/LU                  lu-template-variables
    (:permit-type/L :permit-type/LS) l-template-variables
    :permit-type/CR                  cr-template-variables
    :permit-type/PW                  pw-template-variables
    :permit-type/PWO                 pwo-template-variables
    (unimplemented-error-handler)))

(defn picker-variables-for-type
  "Hide unit-related placeholders when `:feature-flag.id/property-db-units` is off."
  [permit-type feature-flags]
  (template-model/filter-unit-placeholders (variables-for-type permit-type) feature-flags))
